import * as React from 'react';

import OCButton from '~/components/button';
import { LinkWithoutModalContext as Link } from '~/components/link';

import Icon from '~/components/icon';

// hooks
import useMedia from '../../../hooks/use-media';

// providers
import { useServicesContext } from '~/providers/services-context';

// services
import {
  TRACKING_ACTIONS,
  TRACKING_CATEGORIES,
  TRACKING_EVENTS } from
'~/services/actions/tracking-actions';

// context
import { BetslipContext } from '../betslip';

// interfaces
import type IBet from '../interfaces/IBet';

// styles
import styles from '../style/betslip.module.css';

interface IButtonSectionProps {
  bets: IBet[];
  bookie: unknown;
  clearBetslip: () => void;
  numberOfBets: number;
}

function ButtonSection({
  bets,
  bookie,
  clearBetslip,
  numberOfBets
}: IButtonSectionProps) {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);

  const { isMobile } = useMedia();

  const { labelActions, trackingActions } = useServicesContext();

  const betslipContext: any = React.useContext(BetslipContext);

  const betIds = bets.map((bet) => bet.betId);

  if (!mounted) return null;

  if (numberOfBets === 0) {
    return (
      <div className={styles.singleButtonSection}>
				<Link className={styles.singleButton} to="free-bets">
					{labelActions.get('EXPLORE_FREE_BETS')}
				</Link>
			</div>);

  }

  return (
    <div className={styles.buttonSection}>
			<OCButton className={styles.button} onClick={clearBetslip} type="primary">
				{isMobile ?
        <div className="icondelete icondeletesize" /> :

        labelActions.get('DELETE_ALL')
        }
			</OCButton>
			<OCButton
        className={styles.button}
        onClick={() => {
          trackingActions.eventTracking({
            event: TRACKING_EVENTS.BET_ON_BOOKMAKER_SITE,
            eventCategory: TRACKING_CATEGORIES.BETTING,
            eventAction:
            TRACKING_ACTIONS[TRACKING_EVENTS.BET_ON_BOOKMAKER_SITE],
            eventLabel: bookie.bookie
          });
          betslipContext.handleClickOut(bookie.bookmakerCode, betIds);
        }}
        type="secondary">

				<Icon height={16} width={16} icon="Clickout" />
				{labelActions.get('BET_ON_BOOKMAKER_WEBSITE')}
			</OCButton>
		</div>);

}

export default ButtonSection;